/* istanbul ignore file */
import React from 'react';
import { CreateBreadcrumbItem } from 'framework/ui/BreadCrumbs';
import VacancyPublicationBreadcrumbs from 'domain/recruiting/vacancy/publication/shared/VacancyPublicationBreadcrumbs';

const CreateVacancyPublicationBreadcrumbs = () => {
  return (
    <VacancyPublicationBreadcrumbs>
      <CreateBreadcrumbItem entity="Vacancy Publication" />
    </VacancyPublicationBreadcrumbs>
  );
};

export default CreateVacancyPublicationBreadcrumbs;
